import React, { useState } from 'react';

export default (props: { mystep: number; onPressBack: any }) => {
  const { mystep, onPressBack } = props;
  const [mess, setMess] = useState('LA MIA POSIZIONE');
  if (mystep == 3) {
    setMess('LA MIA DIREZIONE');
  }
  return (
    <div className='topnav'>
      <div className='divbtnback'>
        <button onClick={onPressBack}>
          <b>{'     <<<    '}</b>
        </button>
      </div>
      <div className='center'>
        <b>{mess}</b>
      </div>
    </div>
  );
};
